var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMainPadOnHeartSvg = function SvgMainPadOnHeartSvg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19 5.00558C18.9882 5.97228 18.7958 6.92823 18.4327 7.82401C17.4941 8.82159 16.3625 9.61726 15.1069 10.1625C13.8512 10.7078 12.4978 10.9912 11.1293 10.9955C5.71596 10.9955 1.28525 6.64307 0.869934 1.10766C1.60378 0.515176 2.49006 0.142803 3.42632 0.0335863C4.36258 -0.0756301 5.31058 0.0827698 6.16073 0.490475C7.01089 0.898179 7.72848 1.53854 8.23056 2.33753C8.73264 3.13652 8.99869 4.06151 8.99797 5.00558C9.02432 3.6946 9.56279 2.44623 10.4978 1.52842C11.4328 0.610605 12.6898 0.0965247 13.999 0.0965247C15.3082 0.0965247 16.5652 0.610605 17.5002 1.52842C18.4352 2.44623 18.9737 3.6946 19 5.00558Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMainPadOnHeartSvg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mainPadOnHeartSvg.830af87b.svg";
export { ForwardRef as ReactComponent };